import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { ReactNode } from 'react';

interface SlidePanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
}

export function SlidePanel({ open, onOpenChange, title, description, children }: SlidePanelProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm transition-opacity duration-200 data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out" />
        <DialogPrimitive.Content
          className="fixed right-0 top-0 z-50 h-full w-full max-w-md bg-white shadow-2xl
            data-[state=open]:animate-slide-in-right data-[state=closed]:animate-slide-out-right
            flex flex-col overflow-hidden"
        >
          <div className="flex items-start justify-between px-6 py-5 border-b border-grey-200 shrink-0">
            <div>
              <DialogPrimitive.Title className="text-heading-3 text-secondary">
                {title}
              </DialogPrimitive.Title>
              {description && (
                <DialogPrimitive.Description className="text-body-sm text-grey-500 mt-1">
                  {description}
                </DialogPrimitive.Description>
              )}
            </div>
            <DialogPrimitive.Close className="p-1 rounded-lg hover:bg-grey-100 text-grey-400 hover:text-grey-600 transition-colors">
              <X className="w-5 h-5" />
            </DialogPrimitive.Close>
          </div>
          <div className="flex-1 overflow-y-auto px-6 py-5">
            {children}
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
